import {Hub} from 'yougile-model'
import {Task} from '@extensions/task'

export const getTaskTitle = (task: Hub): string => {
  return Task.getTitle(task.id)
}
